import React, { useState, useEffect } from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import { CircularProgress } from "@material-ui/core";
import Modal from "../modals/Modal";
import InputComponent from "../partner/components/inputComponent";
import InputNumber from "./component/inputNumber";

// styles
import useStyles from "../products/styles";
import useStylesTable from "../products/styles";
import config from "../../config";

export default function BoxEgress() {
  const classes = useStyles();
  const classesTable = useStylesTable();

  const [baseUrl, setBaseUrl] = useState(config.config[0].baseUrl);
  const [egressType, setEgressType] = useState({ text: '', valid: null });
  const [total, setTotal] = useState(null);

  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [keyTotal, setKeyTotal] = useState(1);

  const expressions = {
    numbers: /^[0-9]*$/, // 7 a 14 numeros.
    texto: /^[a-zA-Z0-9À-ÿ\s.()_-]{4,500}$/,
  }

  const closeModalLogin = e => {
    setShowModal(false);
  }

  const onSave = async e => {
    e.preventDefault();
    setIsLoading(true);

    const date = new Date();
    var today = "";
    var day = "";

    if (date.getDate() < 10) {
      day = '0' + date.getDate();
    } else {
      day = date.getDate();
    }

    if ((date.getMonth() + 1) < 10) {
      today = day + '/0' + (date.getMonth() + 1) + '/' + date.getFullYear();
    } else {
      today = day + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();
    }
    var currentTime = date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();

    const newEgress = {
      name: egressType.text, total: total, idUser: localStorage.getItem("idUserSystem"), creationDate: today, creationTime: currentTime
    };

    const response = await fetch(baseUrl + "createEgressToCashOut", {
      method: 'POST',
      headers: {
        'Accept': 'application/json', 'Content-Type': 'application/json',
        'Authorization': localStorage.getItem("token")
      },
      body: JSON.stringify(newEgress)
    });

    const json = await response.json();
    if (json.message == "Ok") {
      setEgressType({ text: '', valid: null });
      setTotal(null);
      setKeyTotal(keyTotal + 1);
    } else {
      if (json.message == "Access is denied") {
        setShowModal(true);
      }
    }

    setIsLoading(false);
  }

  return (
    <>
      <Modal
        isOpen={showModal}
        closeModal={closeModalLogin}
      />

      <div className={classes.divTitle}>
        <PageTitle title="Retiros de caja" />
      </div>

      <div className={classesTable.divCard} >
        <div className={classesTable.divColumn} >
        <InputComponent
            text={egressType}
            setPartnerCode={setEgressType}
            type="text"
            label="Concepto"
            name="egressType"
            regularExpression={expressions.texto}
            placeholder="Gasto"
            isRequired={true}
          />

          <InputNumber
            text={total}
            setValue={setTotal}
            label="Importe"
            name="total"
            placeholder="0"
            isRequired={true}
            key={keyTotal}
          /> 
        </div>
      </div>

      <div className={classes.divButton}>
        {isLoading ? (
          <div className={classes.loginLoader} >
            <CircularProgress size={26} />
          </div>
        ) : (
          <button
            className={ egressType.valid == 'true' && total != null & total > 0 ?
              classes.enableButton : classes.disableButton}
            disabled={!( egressType.valid == 'true' && total != null & total > 0 )}
            onClick={onSave}
          >GUARDAR</button>
        )}
      </div>
    </>
  );
}
